import script from "./purchase_box.vue?vue&type=script&setup=true&lang=js"
export * from "./purchase_box.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__